import { Item as ItemModel } from 'models/Recommendation/Item';
import React, { useState } from 'react';
import { PlaceholderImage } from './PlaceholderImage';

export interface RecommendationImageProps {
	item: ItemModel;
	classNameSuffix: string;
}

/**
 * Renders image for hawksearch recommended product.
 */
export function Image({ item }: RecommendationImageProps) {
	const imageUrl: string = item.imageUrl;
	const itemName: string = item.itemName;
	const [hasImage, setHasImage] = useState(imageUrl !== '' && !!imageUrl);
	const [imageLoaded, setImageLoaded] = useState(false);

	return (
		<>
			{hasImage ? (
				<div style={imageLoaded ? {} : { overflow: 'hidden', width: '0px', height: '0px' }}>
					<div
						onLoad={() => setImageLoaded(true)}
						onError={() => {
							setHasImage(false);
							setImageLoaded(false);
						}}
						role="presentation"
					>
						<div className="roc-product-list__image-wrapper">
							<img src={imageUrl} alt={`${itemName}`} className="roc-product-list__image" />
						</div>
					</div>
				</div>
			) : null}

			{!imageLoaded ? (
				// if the main image hasn't loaded yet, show a placeholder
				<div className="roc-product-list__image-wrapper">
					<PlaceholderImage showSpinner={hasImage} name={item.itemName} />
				</div>
			) : null}
		</>
	);
}
